module.exports = __webpack_public_path__ + "static/img/copper-ore_64.f4dd7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copper-ore_64.png
// module id = 8XJb
// module chunks = 0